import { PackageContentProps, PackageSlide } from '../../../models/slides/PackageSlide';
import { formatEurPrice, formatHufPrice } from 'shared-widget-components/src/utils/FormatPrice';

/**
 * PackagePriceContent component
 * this component is responsible for rendering the package price content
 * @param packageData - the data of the package
 * @param calculatedDiscount - the calculated discount
 * @returns PackagePriceContent component
 */

export const PackagePriceContent = ({ packageData, calculatedDiscount }: PackageContentProps) => {
  if (!calculatedDiscount) {
    return (
      <div className='flex h-full items-end'>
        {packageData.basePrice && <h1 className='text-black min-[350px]:text-[20px] sm:text-[24px] font-semibold mr-4 font-body'>{formatHufPrice(packageData.basePrice)}</h1>}
        {packageData.showEurPrice && packageData.baseEurPrice && <h1 className='text-black min-[350px]:text-[20px] sm:text-[24px] font-semibold font-body'>({formatEurPrice(packageData.baseEurPrice)})</h1>}
      </div>
    );
  }
  return (
    <div className='flex flex-col gap-1'>
      <div className='flex items-center min-[350px]:mb-0 min-[1200px]:mb-1'>
        {packageData.currentPrice && <h1 className='text-[#C01010] min-[350px]:text-[20px] sm:text-[24px] font-semibold mr-2 font-body'>{formatHufPrice(packageData.currentPrice)}</h1>}
        {packageData.basePrice && <h1 className='text-black opacity-40 min-[350px]:text-[20px] sm:text-[24px] line-through font-semibold font-body'>{formatHufPrice(packageData.basePrice)}</h1>}
      </div>

      <DiscountedEurPrices packageData={packageData} />
    </div>
  );
};

interface DiscountedEurPriceProps {
  packageData: PackageSlide;
}

const DiscountedEurPrices = ({ packageData }: DiscountedEurPriceProps) => {
  if (!packageData.showEurPrice || !packageData.currentEurPrice || !packageData.baseEurPrice) return null;
  return (
    <div className='flex items-center'>
      {packageData.showEurPrice && <h1 className='text-[#C01010] min-[350px]:text-[16px] sm:text-[20px] mr-2 font-semibold font-body'>({formatEurPrice(packageData.currentEurPrice)}</h1>}
      {packageData.showEurPrice && <h1 className='text-black opacity-40 line-through font-semibold min-[350px]:text-[16px] sm:text-[20px] font-body'>{formatEurPrice(packageData.baseEurPrice)})</h1>}
    </div>
  );
};
